const LETTER_PATTERN = /[A-ZÀÂÄÉÈÊËÏÎÔÙÛÜŸÇÑ]/;

export function parsePuzzleDetails(details) {
    if (!details) return null;
    if (typeof details === "string") {
        try {
            return JSON.parse(details);
        } catch {
            return null;
        }
    }
    return details;
}

export function extractTotalScore(details) {
    const parsed = parsePuzzleDetails(details);
    if (!parsed || typeof parsed !== "object") return null;
    const direct = parsed.totalScore;
    if (direct != null && direct !== "" && Number.isFinite(Number(direct))) {
        return Number(direct);
    }
    const nested = parsed.wordScores?.totalScore;
    if (nested != null && nested !== "" && Number.isFinite(Number(nested))) {
        return Number(nested);
    }
    return null;
}

export function getWheelCharactersFromWords(wordsInUse) {
    const letters = new Set();
    (wordsInUse || "")
        .split("\n")
        .map((w) => w.trim())
        .filter(Boolean)
        .forEach((word) => {
            word.toUpperCase().split("").forEach((ch) => {
                if (LETTER_PATTERN.test(ch)) {
                    letters.add(ch);
                }
            });
        });
    return [...letters].sort((a, b) => a.localeCompare(b));
}

/** Wheel tile count: each letter appears max(count in any single word) times. */
export function getWheelTileCountFromWords(wordsInUse) {
    const maxFreq = {};
    (wordsInUse || "")
        .split("\n")
        .map((w) => w.trim())
        .filter(Boolean)
        .forEach((word) => {
            const wordFreq = {};
            word.toLowerCase().split("").forEach((ch) => {
                if (/[a-zàâäéèêëïîôùûüÿçñ]/.test(ch)) {
                    wordFreq[ch] = (wordFreq[ch] || 0) + 1;
                }
            });
            Object.entries(wordFreq).forEach(([ch, count]) => {
                maxFreq[ch] = Math.max(maxFreq[ch] || 0, count);
            });
        });
    return Object.values(maxFreq).reduce((sum, count) => sum + count, 0);
}

export function getWheelTileCountFromRow(row) {
    const details = parsePuzzleDetails(row?.details);
    if (Array.isArray(details?.characters)) {
        return details.characters.length;
    }
    return getWheelTileCountFromWords(row?.wordsInUse);
}
